import { render, staticRenderFns } from "./MessageEcSite.vue?vue&type=template&id=191b272e&scoped=true&"
import script from "./MessageEcSite.vue?vue&type=script&lang=js&"
export * from "./MessageEcSite.vue?vue&type=script&lang=js&"
import style0 from "./MessageEcSite.vue?vue&type=style&index=0&id=191b272e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191b272e",
  null
  
)

export default component.exports